// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StreamerVideo__container-e7d088 {
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  background-color: var(--addition-40);
  overflow: hidden;
  position: relative;
  border-radius: 8px;
}

.StreamerVideo__container-e7d088:hover {
  cursor: pointer;
}

.StreamerVideo__video-aee800 {
  flex: 1;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/main/LiveStreaming/SharedComponents/Streamers/StreamerVideo/styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,oBAAA;EACA,wBAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,OAAA;EACA,YAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  align-items: stretch;\n  justify-content: stretch;\n  background-color: var(--addition-40);\n  overflow: hidden;\n  position: relative;\n  border-radius: 8px;\n}\n\n.container:hover {\n  cursor: pointer;\n}\n\n.video {\n  flex: 1;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `StreamerVideo__container-e7d088`,
	"video": `StreamerVideo__video-aee800`
};
module.exports = ___CSS_LOADER_EXPORT___;
